import { gql } from '@apollo/client'

export const affiliateLinkClickCreateOne = gql`
  mutation AffiliateLinkClickCreateOne($affiliate: String!) {
    affiliateLinkClickCreateOne(record: { affiliate: $affiliate }) {
      recordId
    }
  }
`
